/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { forwardRef, Ref } from 'react';
import BasicBudget, { BasicBudgetProps } from './Budget';
import AdvancedBudget from './AdvancedBudget';

type BudgetProps = BasicBudgetProps & { budgetType: 'basic' | 'advanced' };

export default forwardRef(
  ({ budgetType = 'basic', ...props }: BudgetProps, ref: Ref<BasicBudget>) =>
    budgetType === 'basic' ? (
      <BasicBudget ref={ref} {...props} />
    ) : (
      <AdvancedBudget ref={ref} {...props} />
    )
);
